import { AxiosInstance } from 'axios'
import { BaseListParams, PaginatedResponse } from '../../base.type'
import { Catalog, CatalogCreate, CatalogUpdate } from '../catalog.type'

export class MasterTypeApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all master-types with pagination
     */
    async list(params?: BaseListParams): Promise<PaginatedResponse<Catalog>> {
        const response = await this.client.get<PaginatedResponse<Catalog>>('/master-types', {
            params,
        })
        return response.data
    }

    /**
     * Get all master-type record detail with pagination
     */
    async listCatalog(
        params?: BaseListParams & {
            masterTypeId: string
        },
    ): Promise<PaginatedResponse<Catalog>> {
        const response = await this.client.get<PaginatedResponse<Catalog>>('/master-data', {
            params,
        })
        return response.data
    }

    /**
     * Get a single master-types by ID
     */
    async findOne(id: string): Promise<Catalog> {
        const response = await this.client.get<Catalog>(`/master-types/${id}`)
        return response.data
    }

    /**
     * Create a new master-types
     */
    async create(payload: CatalogCreate): Promise<Catalog> {
        const response = await this.client.post<Catalog>('/master-types', payload)
        return response.data
    }

    /**
     * Create a new record of master-types (detail list)
     */
    async createCatalog(payload: CatalogCreate): Promise<Catalog> {
        const response = await this.client.post<Catalog>('/master-data', payload)
        return response.data
    }

    /**
     * Update a master-types
     */
    async update(id: string, payload: CatalogUpdate): Promise<Catalog> {
        const response = await this.client.put<Catalog>(`/master-data/${id}`, payload)
        return response.data
    }

    /**
     * Delete a master-types
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/master-data/${id}`)
    }
}
